export default __webpack_public_path__ + "dojo.feb2b636.png";